<template>
    <b-container>

        <b-card v-if="wardId!==null">
                    <b-overlay
          id="overlay-background"
          :show="show">
        <h1 class="mb-3">Name: {{ward.ward_name}}, {{ward.ward_city}}</h1>
        <h4 class="mb-3">Stake: {{stake.stake_name}}, {{stake.stake_city}}</h4>
        <b-row class="mb-3 mt-3">
        <b-col align="left">
        <b-dropdown text="Actions" v-if="wardId!==null" no-flip>
            <b-dropdown-item v-if="isInRole('canModifyWard')" :to="{name: 'ward-detail', params: { 'wardId': wardId}}"><font-awesome-icon icon="edit" /> Edit {{ward.ward_name}}</b-dropdown-item>
            <b-dropdown-item v-if="isInRole('canModifyOrganizations')" :to="{name: 'ward-organizations', params: { 'wardId': wardId}}"><font-awesome-icon icon="edit" /> Organizations/Groups</b-dropdown-item>
            <b-dropdown-item v-if="isInRole('canViewWardUsers')" :to="{name: 'ward-user-list', params: { 'wardId': wardId}}"><font-awesome-icon icon="user" /> Ward Users</b-dropdown-item>
            <b-dropdown-item v-if="isInRole('canAdminTwilioProfiles')" :to="{name: 'ward-twilio-setup', params: { 'wardId': wardId}}"><font-awesome-icon icon="user" /> Twilio Configuration</b-dropdown-item>
            <b-dropdown-divider v-if="isInRole('canModifyWard') || isInRole('canModifyOrganizations') || isInRole('canViewWardUsers')"></b-dropdown-divider>
            <b-dropdown-item v-if="isInRole('canCreateContact')" :to="{name: 'ward-contact', params: { 'wardId': wardId, 'contactId':null, 'stakeId': stake.stake_id}}"><font-awesome-icon icon="plus" /> Add Contact</b-dropdown-item>
            <b-dropdown-item v-if="isInRole('canImportStaticContacts')" :to="{name: 'ward-bulk-import-list', params: {'wardId': wardId, 'stakeId': stake.stake_id}}"><font-awesome-icon icon="file-import" /> Import Contacts</b-dropdown-item>
            <b-dropdown-divider v-if="isInRole('canCreateContact') || isInRole('canImportStaticContacts')"></b-dropdown-divider>
            <b-dropdown-item v-if="isInRole('canSendMessages')" :to="{name: 'ward-notification', params: { 'wardId': wardId, 'stakeId': stake.stake_id}}"><font-awesome-icon icon="sms" /> Send/Create Message</b-dropdown-item>
            <b-dropdown-item v-if="isInRole('canSendMessages')" :to="{name: 'ward-message-list', params: { 'wardId': wardId, 'stakeId': stake.stake_id}}"><font-awesome-icon icon="sms" /> Outbound Messages</b-dropdown-item>
            <b-dropdown-item v-if="isInRole('canSendMessages')" :to="{name: 'ward-message-inbound-list', params: { 'wardId': wardId, 'stakeId': stake.stake_id}}"><font-awesome-icon icon="sms" /> Inbound Messages</b-dropdown-item>
            <b-dropdown-divider v-if="isInRole('canSendMessages')"></b-dropdown-divider>
            <b-dropdown-item v-if="isInRole('canAdminContactAppointments')" :to="{name: 'appointment-list', params: { 'wardId': wardId, 'stakeId': stake.stake_id}}"><font-awesome-icon icon="calendar" /> Appointments</b-dropdown-item>
        </b-dropdown>
        </b-col>
        </b-row>
        <b-row class="mb-3 mt-3">
            <b-col>
                  <b-input-group>
      <b-input-group-prepend is-text>
        <font-awesome-icon :icon="['fa', 'search']"/>
      </b-input-group-prepend>
                <b-form-input v-model="searchTerm" placeholder="Search for First Name, Last Name or Phone Number" @input="delaySearchContacts"></b-form-input>
                  </b-input-group>
            </b-col>
            <b-col>
                  <b-input-group>
      <b-input-group-prepend is-text>
        <font-awesome-icon :icon="['fa', 'filter']"/>
      </b-input-group-prepend>
                <b-form-select v-model="orgSelected" :options="active_organizations" @change="filterWard()"></b-form-select>
                  </b-input-group>
            </b-col>
        </b-row>
        </b-overlay>
        <b-row>
        <b-col>
        <b-table
            :fields="table.fields"
            :items="table.items"
            :busy="table.isBusy"
            :tbody-tr-class="rowClass"
            class="mb-3"
            light
            responsive
            show-empty
            empty-text="No Contacts to show"
            outlined>
            <template #cell(consent_state)="row">
                <span title="Unsubscribed"
                      v-b-tooltip.hover.v-danger
                      v-if="row.item.disabled && row.item.consent_state==='UNSUBSCRIBED'">
                  <font-awesome-icon :icon="['fas', 'exclamation-circle']" />
                </span>
                <span title="Disabled"
                      v-b-tooltip.hover.v-warning
                      v-if="row.item.disabled && row.item.consent_state!=='UNSUBSCRIBED'">
                  <font-awesome-icon :icon="['fas', 'exclamation-circle']" />
                </span>
                <span title="Enrolled"
                      v-b-tooltip.hover
                      v-if="!row.item.disabled && row.item.consent_state=='ENROLLED'">
                  <font-awesome-icon :icon="['fas', 'check-circle']" />
                </span>
            </template>
            <template #cell(full_name)="row">
                {{row.item.first_name}} {{row.item.last_name}}
            </template>
            <template #cell(phone_number)="row">
                <font-awesome-icon :icon="(row.item.send_through_whatsapp) ? 'fa-brands fa-whatsapp' : 'sms'" /> {{formatPhoneNumber(row.item.phone_number)}}
            </template>
            <template #cell(primary_organization)="row">
                  {{getOrganizationInfo(row.item.primary_organization).text}}
              </template>
            <template v-slot:cell(Action)="row">
                <b-button
                    :key="row.item.uid"
                    :to="{name: 'ward-contact-notes', params: { 'wardId': wardId, 'contactId': row.item.contact_id, 'stakeId': row.item.stake_id}}"
                    :variant="isInRole('canModifyContact') && !row.item.disabled ? 'outline-secondary': 'danger'">
                <font-awesome-icon icon="eye" />
                </b-button>
            </template>
            <template #table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
                        <template #cell(show_details)="row">
                          <b-button size="sm" @click="row.toggleDetails" class="mr-2" v-if="getContactOrganizationBreakdown(row.item).all_aux_orgs_counts > 0 ">
                            {{ row.detailsShowing ? 'Hide' : 'Show'}} ({{getContactOrganizationBreakdown(row.item).all_aux_orgs_counts}})
                          </b-button>

                        </template>
                        <template #row-details="row">
                          <b-card>
                            <b-row class="mb-2">
                              <b-col sm="3" class="text-sm-right"><b>Primary Organization/Group:</b></b-col>
                              <b-col><pre>{{ getOrganizationInfo(row.item.primary_organization).text}}</pre></b-col>
                            </b-row>

                            <b-row class="mb-2">
                              <b-col sm="3" class="text-sm-right"><b>Auxilary Organizations/Groups:</b></b-col>
                              <b-col><pre>{{ (getContactOrganizationBreakdown(row.item).all_aux_orgs_counts > 0) ? getContactOrganizationBreakdown(row.item, '\n').pretty_print:''}}</pre></b-col>
                            </b-row>
                          </b-card>
                        </template>
        </b-table>
        </b-col>
        </b-row>
        <b-row>
            <b-col align="center">
        <b-button-group v-if="pages.length>1">
            <b-button @click="searchWard(currentPage-1)">Prev</b-button>
            <b-button @click="searchWard(currentPage+1)">Next</b-button>
        </b-button-group>
            </b-col>
        </b-row>
        </b-card>
    </b-container>
</template>
<script>
import { WardApi } from "@/app/wards/wardApi";
import { userMixin } from "@/mixins/userMixin";
import handleError from "@/errorHandler";
import { organizationMixin } from "@/mixins/organizationMixin";
import _ from "lodash";
export default {
    name: "WardList",
    props: {
        wardId: {
            type: String,
            required: false,
            default: null
        }
    },
    mixins: [userMixin, organizationMixin],
    data () {
        return {
            ward : {
                ward_id: null,
                families: [],
                stake: {},

            },
            nextPage : {
                aux_id : null,
                pk_id : null,
                gsi_pk: null,
                gsi_sk: null,
                org_filter: null
            },
            prevPage: {
                aux_id : null,
                pk_id : null,
                gsi_pk: null,
                gsi_sk: null,
                org_filter: null
            },
            pages:[],
            currentPage: 0,
            lastPage:0,
            orgSelected : "WARD",
            searchTerm : null,
            //organizations : [],
            //aux_organizations:[],
            table: {
                id: "ward-list",
                isBusy: false,
                fields: [
                    {
                        key: "consent_state",
                        label: "Status"

                    },
                    {
                        key: 'full_name',
                        label: 'Name'

                    },
                    {
                        key: "phone_number",
                        label: "Phone Number"
                    },
                    {
                        key: 'primary_organization',
                        label: 'Primary Org/Group'

                    },
                    {
                        key: "show_details",
                        label: "Aux Orgs/Groups"

                    },
                    {
                        key: "Action",
                        label: "View"
                    }
                ],
                items: [],
                totalRows: 0,
                page: {
                    index: 1,
                    size: 5
                }
            },
            stake: {
                stake_id: null
            },
            wardName: null,
            stakeName: null,
            show: false
        }
    },
    async mounted() {
        this.show = true;
        this.table.isBusy = true;
        await this.$store.dispatch('frontEndSettings/loadWardLanguages', this.wardId);
        await this.getOrganizations(this.wardId);
        if (this.$store.state.ward.selectedOrgFilter!==null) {
            let findOrg = this.allOrganizations.find(x=>x.org_code === this.$store.state.ward.selectedOrgFilter);
            if (findOrg !== undefined)
              this.orgSelected = this.$store.state.ward.selectedOrgFilter;
        }

        this.pages.push(this.nextPage);
        await this.searchWard(0);
        this.$store.dispatch('ward/saveOrgFilter', this.orgSelected);
        this.show = false;
        this.table.isBusy = false;

    },
    methods: {
        async searchWard(page) {
            if(page < 0){
                return;
            }
            if(page > this.pages.length-1){
                return;
            }
            const payload = this.pages[page];
            payload.org_filter = this.orgSelected;
            payload.search_term = this.searchTerm;
            this.table.isBusy = true;
            try{
                const { data } = await WardApi.getWardList(this.wardId, payload);
                this.ward = data.ward;
                this.stake = data.stake;
                this.wardName = data.ward.ward_name;
                this.stakeName = data.stake.stake_name;
                if(data.last_evaluated_key !== null){
                    if(!this.existInPageList(data.last_evaluated_key, this.pages))
                        this.pages.push(data.last_evaluated_key);
                }
                this.table.items = data.contact_list;
                this.table.isBusy = false;
                this.currentPage = page;
            }catch (e) {
                handleError(e, "Failed to fetch ward list");
            }finally{
                this.table.isBusy = false;
            }

        },
        async filterWard() {
            this.pages = [];
            this.currentPage = 0;
            this.lastPage = 0;
            this.pages.push(this.nextPage);
            await this.searchWard(0);
            this.$store.dispatch('ward/saveOrgFilter', this.orgSelected);
        },
        existInPageList(obj, list) {
            if(list.length==0) return false;
            var i;
            for (i = 0; i < list.length; i++) {
                if (list[i].pk_id === obj.pk_id && list[i].aux_id === obj.aux_id) {
                    return true;
                }
            }
            return false;

        },
        getOrganizationInfo(value) {
            var i;
            for (i=0; i < this.all_organizations.length; i++) {
                if(this.all_organizations[i].value==value)
                    return this.all_organizations[i];
            }
        },
        flattenInAuxCompositeOrgs(primary_org) {
            let orgs = [];
            this.aux_organizations.forEach(x=>{
                if (x.composite_orgs!==null) {
                    if( x.composite_orgs.includes(primary_org))
                    {
                        let org_name = (x.disabled) ? `${x.text}[Disabled]`:`${x.text}`;
                        orgs.push(org_name);
                    }
                }
            });
            return orgs.length >0 ? orgs.join('\n' ) : null ;
        },
        countInAuxCompositeOrgs(primary_org)
        {
            let orgs = [];
            this.all_organizations.forEach(x=>{
                if (x.composite_orgs!==null) {
                    if( x.composite_orgs.includes(primary_org))
                    {
                        orgs.push(this.org_name);
                    }
                }
            });
            return orgs.length;
        },
        flattenAuxOrganizations(list_of_orgs) {
            if(list_of_orgs === undefined) return '';
            if(list_of_orgs.length==0) return '';
            return list_of_orgs.map(x=>
            {
                if (x !=='None') return this.getOrganizationInfo(x).text;
            }).join('\n');

        },
        rowClass(item, type) {
            if (!item || type !== 'row') return;
            if (item.disabled && item.consent_status === 'UNSUBSCRIBED') return 'table-warning';
            if (item.disabled && item.consent_status !== 'UNSUBSCRIBED') return 'contact-disabled';
        },
      delaySearchContacts: _.debounce(async function() {
        await this.searchWard(0);
      },500)
    }

}
</script>
<style lang="scss">
.contact-disabled {
  color: #757575;
  background-color: #f5f5f5 !important;
}
pre {
    white-space: pre-wrap;       /* Since CSS 2.1 */
    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
}
</style>
